import { render, staticRenderFns } from "./LogoDisplay.vue?vue&type=template&id=620e292d"
import script from "./LogoDisplay.vue?vue&type=script&lang=ts"
export * from "./LogoDisplay.vue?vue&type=script&lang=ts"
import style0 from "./LogoDisplay.vue?vue&type=style&index=0&id=620e292d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports